import { useQuery } from '@tanstack/react-query';

import type { ProcessOfferAttachedEmailDto } from '@/api/generated';

import { useProcessApiClient } from '@/api/clients/useProcessApiClient.util.ts';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Req = { enabled: boolean; processId: string; processOfferId: string };

type Return = {
  emails: ProcessOfferAttachedEmailDto[];
  isPending: boolean;
};

export const useGetProcessOfferEmails = (req: Req): Return => {
  const { processOfferEmailAttachmentApi } = useProcessApiClient();
  const { userId } = useUserContext();

  const { data, isPending } = useQuery<ProcessOfferAttachedEmailDto[]>({
    enabled: req.enabled,
    queryFn: async () => {
      const { data } = await processOfferEmailAttachmentApi.getProcessOfferEmails(
        userId,
        req.processId,
        req.processOfferId,
      );
      return data;
    },
    queryKey: [QueryKeyEnum.PROCESS.OFFER_EMAILS, req.processOfferId],
  });

  return {
    emails: data ?? [],
    isPending: isPending && req.enabled,
  };
};
